import { render } from "./China.vue?vue&type=template&id=bef0883c&scoped=true&ts=true"
import script from "./China.vue?vue&type=script&lang=ts"
export * from "./China.vue?vue&type=script&lang=ts"

import "./China.vue?vue&type=style&index=0&id=bef0883c&scoped=true&lang=less"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef0883c"]])

export default __exports__